import { render, staticRenderFns } from "./MinimalFooter.vue?vue&type=template&id=1c531d95&scoped=true&"
import script from "./MinimalFooter.vue?vue&type=script&lang=js&"
export * from "./MinimalFooter.vue?vue&type=script&lang=js&"
import style0 from "./MinimalFooter.vue?vue&type=style&index=0&id=1c531d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c531d95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
